//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faPlus } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { suggestions } from 'data/addmedia';
import Button from 'components/base/Button';
import { useEffect, useRef } from 'react';
import { TextString, Shape, Slide, Background } from 'data/konva';
import PropTypes from 'prop-types';
import { useSlideEditorContext } from 'providers/SlideEditorProvider';
import {
  CHANGE_BACKGROUN_SLIDE,
  SET_UPDATE_BACKGROUND,
  SET_UPLOADING
} from 'reducers/SlideEditorReducer';

import { uploadImageAndGetUrl } from 'services/uploadImage';

export interface MediaWidgetAddMediaObjectProps {
  slideActiveId: string;
  onAddSlide: (newSlide: Slide) => void;
  onRemoveSlide: (delSlide: Slide) => void;
  onAddTextString: (textString: TextString) => void;
  onAddShape: (shape: Shape) => void;
  onAddImage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAddBackground: (background: Background) => void;
  //onRemoveBackground: (delBackground: Background) => void;
  onClearSlide: () => void;
  onResetAll: () => void;
}
const MediaWidgetAddMediaObject: React.FC<MediaWidgetAddMediaObjectProps> = ({
  slideActiveId,
  onAddSlide,
  onRemoveSlide,
  onAddTextString,
  //onAddShape,
  onAddImage,
  //onRemoveBackground,
  onClearSlide,
  onResetAll
}) => {
  const typeEndRef = useRef<null | HTMLSpanElement>(null);
  //const [selectedFile, setSelectedFile] = useState<File | null>(null);
  // const [error, setError] = useState('');
  const { slideEditorDispatch, activeSlideIndex } = useSlideEditorContext();

  const handleClick = (mediaItem: { mediaItem: string }) => {
    const newSlide: Slide = {
      name: mediaItem.mediaItem
      // Other properties...
    };
    const oldSlide: Slide = {
      slideEditId: slideActiveId,
      name: mediaItem.mediaItem
      // Other properties...
    };
    const newTextString: TextString = {
      slideEditId: slideActiveId,
      name: mediaItem.mediaItem,
      text: 'Double tap to edit text'
    };
    // const newShape: Shape = {
    //   slideEditId: slideActiveId,
    //   name: mediaItem.mediaItem
    //   // Other properties...
    // };
    // const newImage: ImageItem = {
    //   slideEditId: slideActiveId,
    //   name: mediaItem.mediaItem,
    //   //filename: 'image.jpg'
    //   // Other properties...
    // };
    // const newBackground: Background = {
    //   slideEditId: slideActiveId,
    //   name: mediaItem.mediaItem,
    //   filename: 'background.jpg'
    //   // Other properties...
    // };
    // const removeBackground: Background = {
    //   slideEditId: slideActiveId,
    //   name: mediaItem.mediaItem
    //   // Other properties...
    // };
    const fileBackgroundInput = document.getElementById(
      'backgroundInput'
    ) as HTMLInputElement;
    const fileInput = document.getElementById('imageInput') as HTMLInputElement;
    switch (mediaItem.mediaItem) {
      case 'Add slide':
        onAddSlide(newSlide);
        break;
      case 'Remove slide':
        onRemoveSlide(oldSlide);
        break;
      case 'Text':
        onAddTextString(newTextString);
        break;
      // case 'Video'://COMING SOON!!!1
      //   //onAddVideo(newVideo);
      //   break;
      case 'Image':
        if (fileInput) {
          fileInput.click();
        }
        break;
      case 'Edit Background':
        if (fileBackgroundInput) {
          fileBackgroundInput.click();
        }
        break;
      // case 'Remove Background':
      //   onRemoveBackground(newBackground);
      //   break;
      case 'Clear Slide':
        onClearSlide();
        break;
      case 'Reset All':
        onResetAll();
        break;
      default:
        console.log('Default');
        break;
    }
  };

  const handleUploadBackground = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    // setError('');

    if (event.target.files && event.target.files.length > 0) {
      slideEditorDispatch({ type: SET_UPLOADING, payload: true });
      slideEditorDispatch({ type: SET_UPDATE_BACKGROUND, payload: true });
      try {
        const file = event.target.files[0];
        const url = await uploadImageAndGetUrl(file);

        if (url) {
          slideEditorDispatch({
            type: CHANGE_BACKGROUN_SLIDE,
            payload: { index: activeSlideIndex, background: url }
          });
        }
      } finally {
        slideEditorDispatch({ type: SET_UPLOADING, payload: false });
      }
    }
  };

  // const handleBackgroundFileChange = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const file = event.target.files ? event.target.files[0] : null;
  //   if (file) {
  //     const fileUrl = URL.createObjectURL(file);
  //     const newBackground: Background = {
  //       slideEditId: slideActiveId,
  //       name: 'Edit Background',
  //       filename: fileUrl
  //     };
  //     onAddBackground(newBackground);
  //   }
  // };

  // const handleImageFileChange = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const file = event.target.files ? event.target.files[0] : null;
  //   if (file) {
  //     // Revoke the previous image URL
  //     if (fileImageUrl) {
  //       console.log('REVOKE ', fileImageUrl);
  //       URL.revokeObjectURL(fileImageUrl);
  //     }

  //     // Create a new object URL for the selected file
  //     const newFileImageUrl = URL.createObjectURL(file);

  //     // Update state with the new file URL
  //     setFileImageUrl(newFileImageUrl);

  //     // Create a new image object with the new URL
  //     const newImage: ImageItem = {
  //       slideEditId: slideActiveId,
  //       name: 'Add Image',
  //       filename: newFileImageUrl
  //     };

  //     // Call the callback with the new image object
  //     onAddImage(newImage);
  //   }
  // };

  useEffect(() => {
    typeEndRef.current?.scrollIntoView();
  }, []);

  return (
    <>
      {/* {!addMediaObject.mediaItems.length && ( */}
      {
        <div className="text-end w-100 d-flex flex-column">
          {/* <h6 className=" fs-9 mb-3">{slideActiveId}</h6> */}
          {suggestions.map((mediaItem, index) => (
            <Button
              key={mediaItem}
              onClick={() => handleClick({ mediaItem })}
              className={classNames(
                'd-inline-flex align-items-center hover-bg-soft text-black border border-success lh-base btn-block',
                { 'mb-2': index !== suggestions.length - 1 }
              )}
            >
              <p
                className="mb-0 fw-semi-bold fs-9 text-center"
                style={{ width: '100%' }}
              >
                {mediaItem}
              </p>
            </Button>
          ))}
          <input
            type="file"
            id="backgroundInput"
            accept=".png, .jpg, .jpeg, .webp"
            style={{ display: 'none' }}
            onChange={handleUploadBackground}
          />
          <input
            type="file"
            id="imageInput"
            accept=".png, .jpg, .jpeg, .webp"
            style={{ display: 'none' }}
            onChange={onAddImage}
          />
        </div>
      }
      {/* {addMediaObject.mediaItems.length > 0 && (
        <>
          <hr className="my-4 border-dashed border-top border-300" />
          <div className="d-flex flex-column gap-2">
            {addMediaObject.mediaItems.map(mediaItem => (
              <MediaItem
                mediaItem={mediaItem}
                user={addMediaObject.user}
                key={mediaItem.id}
                showActions={false}
              />
            ))}
            <span ref={typeEndRef} />
          </div>
        </>
      )} */}
    </>
  );
};

MediaWidgetAddMediaObject.propTypes = {
  slideActiveId: PropTypes.string.isRequired,
  onAddSlide: PropTypes.func.isRequired,
  onRemoveSlide: PropTypes.func.isRequired,
  onAddTextString: PropTypes.func.isRequired,
  onAddShape: PropTypes.func.isRequired,
  onAddImage: PropTypes.func.isRequired,
  onAddBackground: PropTypes.func.isRequired,
  //onRemoveBackground: PropTypes.func.isRequired,
  onClearSlide: PropTypes.func.isRequired,
  onResetAll: PropTypes.func.isRequired
};

export default MediaWidgetAddMediaObject;
